<template>
    <div class="md-search-seo broker" :class="{ 'in-map-list': inMapList }">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            v-if="showModule"
            class="seo-module-box"
        >
            <div class="search-seo-container">
                <div class="search-seo">
                    <div class="content_wrap">
                        <template v-for="(group, index) in nearbyList">
                            <div
                                :key="index"
                                class="group"
                                :class="{ 'two-columns': inMapList }"
                                v-if="group.list.length > 0"
                            >
                                <h2
                                    class="title"
                                    :class="{ 'in-map-list': inMapList }"
                                >
                                    {{ group.title }}
                                </h2>
                                <ul class="content">
                                    <li
                                        v-for="(item, index) in group.list"
                                        :key="item.name + index"
                                        class="item"
                                    >
                                        <a
                                            class="anchor"
                                            :class="{
                                                'in-map-list': inMapList
                                            }"
                                            :href="item.url"
                                            rel="noopener noreferrer"
                                        >{{ item.name }}</a
                                        >
                                    </li>
                                    <li
                                        class="mobile_more"
                                        v-if="
                                            isMobileSize &&
                                                originList[index] &&
                                                originList[index].length > 5
                                        "
                                        @click="mobileToggleMore(index)"
                                    >
                                        <span>{{
                                            !moreStatusForMobile[index]
                                                ? $t('md-search-seo.showMore')
                                                : $t('md-search-seo.showLess')
                                        }}</span>
                                        <div
                                            class="icon"
                                            :class="{
                                                rotate: moreStatusForMobile[
                                                    index
                                                ]
                                            }"
                                        >
                                            <span
                                                class="iconfont icon-small-down"
                                            ></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                    <div
                        class="action"
                        :class="{ 'in-map-list': inMapList }"
                        v-if="showMoreBtn && !isMobileSize"
                        @click="toggleMore"
                    >
                        <span>{{
                            !moreStatus
                                ? $t('md-search-seo.showMore')
                                : $t('md-search-seo.showLess')
                        }}</span>
                        <div class="icon" :class="{ rotate: moreStatus }">
                            <span class="iconfont icon-small-down"></span>
                        </div>
                    </div>
                </div>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';

.md-search-seo {
    .search-seo-container {
        padding-top: 20px;
    }
    .search-seo {
        .content_wrap {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            transition: height 0.3s ease;
        }
        .group {
            float: 1;
            &.two-columns {
                padding: 0 20px;
            }
            @include media-800 {
                /* padding: 20px 0; */
                padding-bottom: 25px;
                &:last-child {
                    padding-bottom: 0;
                }
                width: 100%;
            }
            .title {
                font-size: 16px;
                font-weight: bold;
                color: #191919;
                font-family: var(--mg-title-font);
            }
            .content {
                padding-top: 15px;
                @include media-800 {
                    padding-top: 10px;
                }
                .item {
                    cursor: pointer;
                    padding: 5px 0;
                    padding-right: 20px;
                    @include media-800 {
                        padding: 4px 0;
                    }
                    .anchor {
                        display: block;
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: 14px;
                        line-height: 16px;
                        font-weight: normal;
                        color: #515666;
                        &:hover {
                            color: var(--color-theme);
                        }
                    }
                }
            }
        }
        .mobile_more {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            color: var(--color-theme);
            font-size: 14px;
            line-height: 16px;
            margin-top: 7px;
            .icon {
                margin-left: 10px;
                transition: transform 0.3s ease;
                &.rotate {
                    transform: rotate(180deg);
                    transform-origin: center center;
                }
                .iconfont {
                    color: var(--color-theme);
                    font-size: 14px;
                }
            }
        }
        .action {
            cursor: pointer;
            margin-top: 10px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--color-theme);
            font-size: 14px;
            line-height: 16px;
            &.in-map-list {
                margin-bottom: 20px;
            }
            .icon {
                margin-left: 10px;
                transition: transform 0.3s ease;
                &.rotate {
                    transform: rotate(180deg);
                    transform-origin: center center;
                }
                .iconfont {
                    color: var(--color-theme);
                    font-size: 14px;
                }
            }
        }
    }
}
</style>
